import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { MODES } from '../../../../utils/constant';
import Icon from '../../../../utils/icons';
import { getFanModeIcon } from '../util';
import { useMobileStyles } from '../styles';
import I18n from '../../../../localization';

const FanModeSelector = ({ iqAirDetails, onFanModeChange, isDarkMode, name='' }) => {
  const classes = useMobileStyles();
  const fanModes = [MODES.AUTO, MODES.CIRCULATE, MODES.ON];

  return (
    <div className={''}>
      <Box className={[classes.IQCard, classes.IQAirMode, classes.InnerCards].join(" ")}>
        <Typography className={classes.cardInnerLabel}>{name? name : I18n.t('mobile.iqAirSetting.fanModeText')}</Typography>

        <Box className={classes.modeCard}>
          {fanModes.map((mode) => {
            return (
              <Box
                onClick={() => onFanModeChange(mode)}
                className={[
                  classes.iconLayout,
                  iqAirDetails.fanMode === mode ? classes.selected : "",
                  classes.addPointer
                ].join(" ")}
                key={mode}
              >
                <Icon
                  src={getFanModeIcon(iqAirDetails.fanMode, mode, isDarkMode)}
                />
              </Box>
            );
          })}
        </Box>
        
        <Box className={[classes.modeCard, classes.modeText].join(" ")} style={{marginTop:'-16px'}}>
          {fanModes.map((mode) => {
            return (
              <Typography
                className={`${classes.iconLayout}`}
                key={mode}
              >
                {mode.charAt(0) + mode.slice(1).toLowerCase()}
              </Typography>
            );
          })}
        </Box>
      </Box>
    </div>
  );
};

export default FanModeSelector;
